package ui.hud

import ui.*

class TouchHUD(
    private val leftArrow: CustomButton,
    private val rightArrow: CustomButton,
    private val jumpButton: CustomButton,
    private val dashButton: CustomButton,
    private val menuButton: CustomButton
) : GameHUD {
    override fun disable() {
        leftArrow.disable()
        rightArrow.disable()
        jumpButton.disable()
        dashButton.disable()
        menuButton.disable()
    }

    override fun enable() {
        leftArrow.enable()
        rightArrow.enable()
        jumpButton.enable()
        dashButton.enable()
        menuButton.enable()
    }
}
